'use strict';

var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Card$1 = require('../../../node_modules/@material-ui/core/esm/Card/Card.js');

var boxShadow = '0px 0px 12px 2px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1)';

var styles = function styles(theme) {
  var _theme$customShadows;

  return {
    root: {
      position: 'relative',
      overflow: 'inherit',
      borderRadius: 8,
      boxShadow: (theme === null || theme === void 0 ? void 0 : (_theme$customShadows = theme.customShadows) === null || _theme$customShadows === void 0 ? void 0 : _theme$customShadows.card) || boxShadow
    }
  };
};
var Card = withStyles(styles)(Card$1["default"]);

module.exports = Card;
